import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './mainlayout.css';
import { Navbar, Nav, Button, Modal, Image, Row, Col, Form } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

function MainLayout() {

  const [show, setShow] = useState(false);

  function getAgent() {
    let param = 'utm_source=web&utm_medium=display&utm_campaign=TelcelSaldoBanner&utm_content=TelcelSaldoBannerDescarga';
    param = window.location.search.substring(1).replaceAll("=", "%3D").replaceAll("&", "%26");
    let url = '';
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {

      url = 'https://play.google.com/store/apps/details?id=com.globalhitss.claro.pay&referrer=utm_source%3Dlanding%26utm_medium%3Dheropage%26utm_campaign%3Dlanding' + param;
    } else if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
      url = 'https://apps.apple.com/mx/app/claro-pay/id1502765283' + window.location.search;
    } else {
      //url = 'https://www.claropay.com/' + window.location.search;
      url = 'https://play.google.com/store/apps/details?id=com.globalhitss.claro.pay&referrer=utm_source%3Dlanding%26utm_medium%3Dheropage%26utm_campaign%3Dlanding' + param;
    }
    return url;
  }

  return (
    <React.Fragment>
      <header>
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light" fixed="top" className="navbarMenu">
          <Navbar.Brand>
            <NavLink to="/">
              <img alt="Claro Pay" src="images/logo-claro-pay.svg" width="150" height="40" />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" className="btnMenu" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto align-menu">
              {/* <a href="#quees" className="nav-link">¿Que es?</a> */}
              {/* <NavLink to="/que-es" className="nav-link" activeClassName="actual-location" >¿Qué es?</NavLink> */}
              {/* <NavLink to="/beneficios" className="nav-link" activeClassName="actual-location">Beneficios</NavLink> */}
              <NavLink to="/faq" className="nav-link" activeClassName="actual-location">Dudas frecuentes</NavLink>
              <NavLink to="/comercios" className="nav-link" activeClassName="actual-location">¿Dónde usar Claro Pay?</NavLink>
              <div className="nav-link">
                <a target="_blank" rel="noreferrer" href={getAgent()} className="link-download">
                  Descarga la app
                </a>
              </div>
            </Nav>
            <div className="btns-nav">
              {/* <div className="nav-link"><Button variant="button-round" onClick={() => setShow(true)}>Mi Cuenta</Button></div>
              <div className="nav-link"><Button variant="button-round" className="btn-highlight" >Crear Cuenta</Button></div> */}
            </div>
          </Navbar.Collapse>
        </Navbar>
      </header>
      {/*
        <button className="BtnFactura">
          <a className="BtnContent" target="_blank" href="https://facturacion.claropay.com" rel="noreferrer">
            <img className="IconFactura" src="images/quiero-facturar.svg" alt="quiero facturar" />
            <p >Quiero <br />facturar</p>
          </a>
        </button>
      */}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="portal-mi-cueta"
      >
        <Modal.Header closeButton>
          <Modal.Title id="portal-mi-cueta">
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="section-center">
            <Row >
              <Col>
                <Image src="images/logo-claro-pay-modal.svg" />
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="text-modal">Ingresa el número de teléfono de tu cuenta Claro Pay</p>
              </Col>
            </Row>
            <Row>
              <Col className="form-modal">
                <Form.Control placeholder="" className="text-form-modal" />
              </Col>
            </Row>
            <Row>
              <Col className="button-modal">
                <Button variant="button-modal-round">Entrar</Button>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

    </React.Fragment>
  );
}

export default MainLayout;